import { NigoAnalysis, useNigoAnalysisContext } from '@client';
import { Button } from './ui/button';
import { FileCheck } from 'lucide-react';

function NigoAnalysisSectionContent() {
  const { data, actions } = useNigoAnalysisContext();
  const showNigoAnalysisView = data.metadata.showNigoAnalysisView;
  const setShowNigoAnalysisView = actions.setShowNigoAnalysisView;

  return (
    <>
      {/* Floating Application Review Button */}
      {(data.ruleResult.length > 0 || data.aiResult) &&
        !showNigoAnalysisView &&
        data.metadata.hasCompletedFormOnce && (
          <div className="fixed right-8 top-8 z-50">
            <Button
              variant="default"
              onClick={() => setShowNigoAnalysisView(true)}
              className="gap-2 shadow-lg"
            >
              <FileCheck className="h-4 w-4" />
              Application Review
            </Button>
          </div>
        )}

      {/* NIGO Analysis View */}
      {showNigoAnalysisView && (
        <div className="space-y-6">
          <div className="mb-4 flex items-center justify-between md:mb-6">
            <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">Application Review</h1>
            <Button
              variant="outline"
              onClick={() => setShowNigoAnalysisView(false)}
            >
              Back to Application
            </Button>
          </div>

          <NigoAnalysis />
        </div>
      )}
    </>
  );
}

export default NigoAnalysisSectionContent;
